<template>
  <span class="x-filter">

    <!-- Render the root group. Child groups are rendered by XFilterGroup -->
    <x-filter-group
      v-if="getRootGroup()"
      :group="getRootGroup()"
      :index="0"
      :filterDefinitions="workingFilterDefinitions"
      @updateGroup="updateGroup"
    />
  </span>
</template>

<script>
import XFilterGroup from "@/components/helpers/DataInput/XFilterGroup"

export default {
  components: { XFilterGroup },
  props: {
    filterDefinitions: {
      type: Array,
      required: true,
    },
    defaultfilters: {
      type: Object,
      default: () => { return {} }
    },
  },
  data() {
    return {
      filters: {},
      workingFilterDefinitions: null,
    }
  },
  beforeMount() {
    // Initialise and add any defaults
    this.filters = _.clone(this.defaultfilters)

    if (typeof this.filters.group == 'undefined' || typeof this.filters.group.conditions == 'undefined') {
      this.filters = {
        group: {
          merge: "",
          conditions: [],
        }
      }
    }

    this.createWorkingDefinitions()
  },
  methods: {
    createWorkingDefinitions() {
      this.workingFilterDefinitions = _.cloneDeep(this.filterDefinitions)

      this.workingFilterDefinitions.forEach((def) => {
        if (def.type == 'date') {

          // If no options are provided, use the defaults
          if (Array.isArray(def.options) == false || def.options.length == 0) {
            let defaultDateRanges = this.$t('ui.xfilters.date_ranges')
            def.options = Object.keys(defaultDateRanges).map((key) => {
              return {
                name: defaultDateRanges[key],
                value: key,
              }
            })
          }

          // If the options are provided as an array of names, convert into name/value pairs
          if (Array.isArray(def.options) && typeof def.options[0] != 'object') {
            def.options = def.options.map((rangeName) => {
              return {
                name: rangeName,
                value: rangeName.toLowerCase().replace(/\s+/g, '_'),
              }
            })
          }

          // If no 'custom' value has been provided, add it
          let exists = def.options.some((option) => {
            return option.value == 'custom'
          })
          if (!exists) {
            def.options = [{
              name: this.$t('ui.xfilters.date_ranges.custom'),
              value: 'custom'
            }].concat(def.options)
          }
        }
      })
    },
    getRootGroup() {
      return _.get(this.filters, 'group', {})
    },
    updateGroup(group, index) {
      // We can ignore index, since we only ever have one root group
      this.filters.group = group
      this.$emit('update', this.filters)
    },
  },
  watch: {
    filterDefinitions: {
      deep: true,
      handler() { this.createWorkingDefinitions() }
    }
  }
}
</script>

<style lang="sass">
.x-filter
  .x-filter-group
    margin: 0
    padding: 0

  .x-filter-block
    display: inline-block
    float: left
    clear: none
    background: $sensual-lighter
    color: $ink
    width: auto
    user-select: none
    margin: 2px
    margin-bottom: 5px
    padding: 8px 12px
    border-radius: 5px
    font-size: 14px
    font-weight: $font-medium
    height: 40px
    line-height: 24px

  .x-filter-condition
    max-width: 100%

  @media (max-width: 480px)
    .x-filter-block
      font-size: 12px
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      padding: 8px 6px
  .x-filter-condition
    @extend .x-filter-block

  .x-filter-operator
    @extend .x-filter-block
    background: #F4F5F8
    color: #636A81
    font-size: 15px
    padding: 8px
    &.x-filter-operator-and
      &::after
        content: "&"
    .x-filter-operator-or
      &::after
        content: "|"

  .icon.x-filter-condition-remove
    display: inline-block
    font-size: 18px
    vertical-align: middle
    margin-left: 6px
    opacity: .37
    cursor: pointer
    &:hover
      opacity: .69

  .x-filter-add-btn
    display: inline-block
    float: left
    vertical-align: middle
    box-sizing: border-box
    box-shadow: none
    border: none
    color: $sensual !important
    cursor: pointer
    font-size: 15px
    font-weight: 500
    height: 40px
    padding: 0px
    margin: 0px
    margin-top: 2px
    margin-left: 2px
    transition: all .15s ease-out
    background: transparent !important
    &:hover
     color: $sensual-dark !important
    .q-focus-helper
      background: white !important
    .q-btn-inner
      &:before
        content: url("../../../assets/plus-icon.svg")
        border: 2px dashed $sensual-light
        background: #fff
        border-radius: 5px
        padding: 10px 12px
        padding-top: 12px
        height: 40px
        margin: 0
        margin-right: 10px
        color: $sensual
        cursor: pointer
        font-weight: 500
    .q-btn-inner
      .on-right
        display: none !important

  .x-filter-modal
    .modal-wrapper
      min-width: 320px
      max-width: 380px
    .modal-component
      overflow: visible
    .x-filter-modal-label
      display: block
      padding-bottom: 12px
      font-weight: $font-medium
    .x-filter-modal-predicates
      display: block
      margin: 0
      margin-bottom: 5px
      padding: 0
      display: flex
      flex-direction: column
      .x-filter-modal-predicate-item
        padding-right: 10px
        margin-bottom: 15px
        align-items: flex-end
    .x-filter-modal-checkbox
      line-height: 21px
      height: 24px
      margin: 0
      padding: 0
      .material-icons
        font-size: 24px !important
      .q-option-inner
      .q-option-label
        line-height: 21px
        height: inherit
        margin-left: 15px
      .q-option-inner
        margin-bottom: 5px
    .q-radio
      span.q-option-label
        line-height: 21px
        margin-left: 15px
      .material-icons
        font-size: 24px !important
    .x-filter-modal-has-none
      display: block
      margin: 0
      padding: 0
    .x-filter-modal-set
      display: block
      margin: 0
      margin-bottom: 0px
      padding: 0
      .q-option
        display: flex
        margin: 0
        margin-bottom: 15px
        padding: 0
        align-items: flex-end
      select

      .x-filter-modal-chips
        .q-chips-input
          border: 2px solid $paper
          border-radius: 3px
          padding: 2px 2px 2px 2px
          margin: 0
          min-height: 40px
          margin-bottom: 20px
          &:hover
            border-color: $paper-dark
          &:focus-within
            border-color: $sensual
    .x-filter-modal-date
      .vdp-datepicker
        &::before
          top: 9px !important
      .vdp-datepicker__clear-button
        top: 7px !important
</style>

// These can't be scoped, since they're targetting Quasar components
<style lang="sass">
.x-filter
  .x-filter-modal
    .x-filter-modal-set
      .x-filter-modal-chips
        .q-chips-input
          .q-input-target
            min-height: 31px !important
          .q-chip
            background-color: $paper !important
            color: $ink-light !important
            padding-right: 16px
            border-radius: 3px
            margin-right: 4px
            min-height: 30px !important
            .q-chip-close
              i
                font-size: 20px
          i.q-icon.q-if-control
            display: none


</style>



// WEBPACK FOOTER //
// XFilter.vue?67eef1a4